var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"top-load-wrapper"},[_c('i',{staticClass:"iconfont",class:{
    'icon-arrow-bottom': _vm.props.state === 'pull',
    'icon-arrow-bottom icon-arrow': _vm.props.state === 'trigger',
    'icon-loading': _vm.props.state === 'loading'
}}),_vm._v(" "+_vm._s(_vm.props.stateText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }